import { render } from "./index.vue?vue&type=template&id=7c853c6d&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modules/Authentication/PasswordRecover/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c853c6d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c853c6d', __exports__)) {
    api.reload('7c853c6d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7c853c6d&ts=true", () => {
    api.rerender('7c853c6d', render)
  })

}


export default __exports__